(function() {
  if (window.ShippingProgressScriptLoaded) {
    if (typeof window.ShippingProgressCheckCart === 'function') {
      window.ShippingProgressCheckCart();
    }
    return;
  }
  window.ShippingProgressScriptLoaded = true;

  var META1_FALLBACK = 600;
  var META2_FALLBACK = 1200;
  var GIFT_MIN_VALUE_FALLBACK = 1200;
  var _giftVariantId = null;
  var _giftBusy = false;
  var _debounceTimer = null;
  var _throttleRetryTimer = null;
  var _pendingCheck = false;
  // Estado próprio do carrossel de escolha de brinde (Tema > Carrinho >
  // Carrossel de escolha de brinde), separado do brinde automático acima -
  // os dois recursos são independentes e não devem travar um ao outro.
  var _giftSelectorBusy = false;
  var _pendingSelectorCheck = false;
  var _originalFetch = window.fetch ? window.fetch.bind(window) : null;
  // Used by PDP shipping calculator to mutate cart without gift/progress side-effects
  window.__originalFetch = _originalFetch;
  var _lastRequestTime = 0;
  var _requestCount = 0;
  var _maxRequestsPerMinute = 30;

  function getGiftScriptEl() {
    return document.getElementById('shipping-progress-script');
  }

  function getProgressWrapper() {
    return document.querySelector('.shipping-progress-wrapper');
  }

  // Valores das etapas configurados em Tema > Carrinho > Barra de progresso do carrinho.
  function getMeta1() {
    var wrapper = getProgressWrapper();
    var value = wrapper ? parseFloat(wrapper.getAttribute('data-meta1')) : NaN;
    return isNaN(value) ? META1_FALLBACK : value;
  }

  function getMeta2() {
    var wrapper = getProgressWrapper();
    var value = wrapper ? parseFloat(wrapper.getAttribute('data-meta2')) : NaN;
    return isNaN(value) ? META2_FALLBACK : value;
  }

  function getStepLabel(markerIndex, fallback) {
    var wrapper = getProgressWrapper();
    var label = wrapper
      ? wrapper.querySelector('.shipping-progress__marker--' + markerIndex + ' .shipping-progress__label')
      : null;
    return label ? label.textContent : fallback;
  }

  // Produto configurado em Tema > Carrinho > Brinde automático.
  // Fica disponível independente do toggle, para a barra de progresso
  // continuar excluindo o brinde do subtotal mesmo se a adição automática
  // estiver desativada (ex: quando um app externo é quem adiciona o item).
  function getGiftProductId() {
    var el = getGiftScriptEl();
    if (!el) return null;
    var id = parseInt(el.getAttribute('data-gift-product-id'), 10);
    return id || null;
  }

  function getGiftHandle() {
    var el = getGiftScriptEl();
    var handle = el ? el.getAttribute('data-gift-handle') : null;
    return handle || null;
  }

  // Valor mínimo configurado em Tema > Carrinho > Brinde automático,
  // independente do valor da etapa 2 da barra de progresso.
  function getGiftMinValue() {
    var el = getGiftScriptEl();
    var value = el ? parseFloat(el.getAttribute('data-gift-min-value')) : NaN;
    return isNaN(value) ? GIFT_MIN_VALUE_FALLBACK : value;
  }

  // Valor mínimo configurado em Tema > Carrinho > Seletor de brinde por foto
  // (settings.gift_selector_min_value) - totalmente independente do valor
  // acima. Em reais (R$), igual ao valor do brinde automático. Retorna null
  // quando não configurado, pra não inventar um fallback pra um recurso que
  // o lojista nunca ativou.
  function getGiftSelectorMinValue() {
    var el = getGiftScriptEl();
    var value = el ? parseFloat(el.getAttribute('data-gift-selector-min-value')) : NaN;
    return isNaN(value) ? null : value;
  }

  // 'classic' (versão 1, valor mínimo único) ou 'tiers' (versão 2, faixas).
  function getGiftSelectorLayout() {
    var el = getGiftScriptEl();
    return (el && el.getAttribute('data-gift-selector-layout')) || 'classic';
  }

  // Controla somente a adição/remoção automática do brinde pelo frontend
  // (settings.enable_automatic_gift). Desative quando um app externo assumir essa regra.
  function isAutoAddEnabled() {
    var el = getGiftScriptEl();
    return !!el && el.getAttribute('data-gift-auto-add') === 'true';
  }

  function formatBRL(value) {
    return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Variante definida em Tema > Carrinho > Brinde automático
  // (settings.automatic_gift_variant_id). O theme.liquid só preenche o
  // atributo quando o ID pertence ao produto configurado.
  function getConfiguredGiftVariantId() {
    var el = getGiftScriptEl();
    var id = el ? parseInt(el.getAttribute('data-gift-variant-id'), 10) : NaN;
    return id || null;
  }

  function getGiftVariantId(handle) {
    if (_giftVariantId) return Promise.resolve(_giftVariantId);
    var configuredId = getConfiguredGiftVariantId();
    if (configuredId) {
      _giftVariantId = configuredId;
      return Promise.resolve(_giftVariantId);
    }
    if (!_originalFetch || !handle) return Promise.resolve(null);
    return _originalFetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (product.variants && product.variants.length > 0) {
          // Produtos com mais de uma variante: prioriza a variante com preço
          // R$0 (a pensada para brinde) em vez de sempre pegar a primeira,
          // que pode ter preço normal e acabar cobrando o "brinde" no checkout.
          var freeVariant = product.variants.find(function(v) { return v.price === 0; });
          _giftVariantId = (freeVariant || product.variants[0]).id;
        }
        return _giftVariantId;
      })
      .catch(function() { return null; });
  }

  // Com variante configurada, só ela é o brinde - outras variantes do mesmo
  // produto compradas pela cliente continuam sendo produtos normais.
  function isConfiguredGiftItem(item, giftProductId) {
    var configuredId = getConfiguredGiftVariantId();
    if (configuredId) return item.variant_id === configuredId;
    return item.product_id === giftProductId;
  }

  // Prioriza a linha já marcada como brinde automático; senão, qualquer linha
  // da variante (ou produto) configurado.
  function findGiftInCart(cart, giftProductId) {
    if (!cart || !cart.items || !giftProductId) return null;
    var fallback = null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isConfiguredGiftItem(item, giftProductId)) continue;
      if (item.properties && item.properties._brinde_automatico === 'true') return item;
      if (!fallback) fallback = item;
    }
    return fallback;
  }

  // Linha marcada por este arquivo (brinde automático) OU pelo seletor de
  // brinde por foto (snippets/gift-selector.liquid). Os produtos do seletor
  // por foto têm preço R$ 0,00 (então já não afetam o total), mas o brinde
  // automático entra pelo valor cheio da variante - os dois precisam ficar
  // fora do total usado pra decidir elegibilidade, senão o próprio brinde
  // "paga" o brinde.
  function isGiftLineItem(item) {
    return !!(
      item.properties &&
      (item.properties._brinde_automatico === 'true' ||
        item.properties._brinde === 'true')
    );
  }

  function findSelectedGiftInCart(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties && cart.items[i].properties._brinde === 'true') {
        return cart.items[i];
      }
    }
    return null;
  }

  function cartTotalWithoutGifts(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isGiftLineItem(cart.items[i])) {
        total += cart.items[i].final_line_price;
      }
    }
    return total;
  }

  function addGiftToCart(variantId) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { '_brinde_automatico': 'true' } }]
      })
    }).then(function(r) { return r.json(); });
  }

  function isAutomaticGift(item) {
    var isAuto = item.properties && item.properties._brinde_automatico === 'true';
    console.log('[ShippingProgress] Checking if gift is automatic:', {
      item: item,
      properties: item.properties,
      _brinde_automatico: item.properties ? item.properties._brinde_automatico : 'not found',
      isAutomatic: isAuto
    });
    return isAuto;
  }

  function convertToAutomaticGift(lineKey, currentQuantity) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: lineKey, 
        quantity: currentQuantity,
        properties: { '_brinde_automatico': 'true' }
      })
    }).then(function(r) { return r.json(); });
  }

  function removeGiftFromCart(lineKey) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function(r) { return r.json(); });
  }

  function setGiftQuantityTo1(lineKey) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 1 })
    }).then(function(r) { return r.json(); });
  }

  function reloadCartSections() {
    if (!_originalFetch) return Promise.resolve();
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : null;
    if (!sectionId) { 
      console.log('[ShippingProgress] No section ID found, reloading page');
      location.reload(); 
      return Promise.resolve(); 
    }

    console.log('[ShippingProgress] Reloading sections:', sectionId);
    return _originalFetch(window.location.pathname + '?sections=' + sectionId + ',cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        console.log('[ShippingProgress] Sections loaded:', Object.keys(sections));
        
        if (cartDrawer && sections[sectionId]) {
          var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');

          // Update the entire cart drawer contents
          var newDrawer = doc.querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) {
            console.log('[ShippingProgress] Updating entire cart drawer');
            
            // Update cart items
            var newCartItems = newDrawer.querySelector('#CartDrawer-CartItems');
            var oldCartItems = oldDrawer.querySelector('#CartDrawer-CartItems');
            if (newCartItems && oldCartItems) {
              oldCartItems.innerHTML = newCartItems.innerHTML;
              console.log('[ShippingProgress] Cart items updated');
            }

            // Update footer
            var newFooter = newDrawer.querySelector('.drawer__footer-bottom');
            var oldFooter = oldDrawer.querySelector('.drawer__footer-bottom');
            if (newFooter && oldFooter) {
              oldFooter.innerHTML = newFooter.innerHTML;
              console.log('[ShippingProgress] Footer updated');
            }

            // Update cart count in drawer
            var newCount = newDrawer.querySelector('.cart-count');
            var oldCount = oldDrawer.querySelector('.cart-count');
            if (newCount && oldCount) {
              oldCount.innerHTML = newCount.innerHTML;
              console.log('[ShippingProgress] Cart count updated');
            }

            // Update gift selector accordion (appears/disappears based on
            // the cart total, same reasoning as applySectionsUpdate)
            var newGiftSelector = newDrawer.querySelector('#CartDrawer-GiftSelector');
            var oldGiftSelector = oldDrawer.querySelector('#CartDrawer-GiftSelector');
            if (newGiftSelector && oldGiftSelector) {
              oldGiftSelector.innerHTML = newGiftSelector.innerHTML;
              console.log('[ShippingProgress] Gift selector updated');
            }

            var newPromoSelector = newDrawer.querySelector('#CartDrawer-PromoSelector');
            var oldPromoSelector = oldDrawer.querySelector('#CartDrawer-PromoSelector');
            if (newPromoSelector && oldPromoSelector) {
              oldPromoSelector.innerHTML = newPromoSelector.innerHTML;
              console.log('[ShippingProgress] Promo selector updated');
            }
          }
        }
        
        // Update cart icon bubble
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = bubbleDoc.getElementById('cart-icon-bubble');
            if (newBubble) {
              bubble.innerHTML = newBubble.innerHTML;
              console.log('[ShippingProgress] Cart icon bubble updated');
            }
          }
        }
        
        console.log('[ShippingProgress] All sections updated successfully');
        return sections;
      })
      .catch(function(error) { 
        console.log('[ShippingProgress] Error reloading sections:', error);
        location.reload(); 
      });
  }

  function runPendingCheck() {
    if (_pendingCheck) {
      _pendingCheck = false;
      setTimeout(checkCartAndUpdate, 150);
    }
  }

  function handleGiftLogic(cart) {
    // Adição/remoção automática desativada (Tema > Carrinho > Brinde automático) -
    // provavelmente um app externo está cuidando disso agora, não mexer no carrinho.
    if (!isAutoAddEnabled()) return;

    var giftProductId = getGiftProductId();
    if (!giftProductId) return;

    if (_giftBusy) {
      _pendingCheck = true;
      return;
    }
    var totalWithoutGift = cartTotalWithoutGifts(cart);
    var totalReais = totalWithoutGift / 100;
    var giftItem = findGiftInCart(cart, giftProductId);
    var giftMinReached = totalReais >= getGiftMinValue();

    // Count non-gift items to handle edge cases (nem o brinde automático,
    // nem o escolhido no carrossel, contam como "produto de verdade" aqui)
    var nonGiftItemCount = 0;
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (!isGiftLineItem(cart.items[i])) {
          nonGiftItemCount++;
        }
      }
    }

    console.log('[ShippingProgress] Cart state:', {
      totalReais: totalReais,
      giftMinReached: giftMinReached,
      nonGiftItemCount: nonGiftItemCount,
      hasGift: !!giftItem,
      isAutomaticGift: giftItem ? isAutomaticGift(giftItem) : false
    });

    // Force remove gift if no regular products remain (only automatic gifts)
    if (nonGiftItemCount === 0 && giftItem && isAutomaticGift(giftItem)) {
      console.log('[ShippingProgress] Force removing automatic gift - no regular products');
      _giftBusy = true;
      removeGiftFromCart(giftItem.key).then(function() {
        console.log('[ShippingProgress] Automatic gift removed successfully, reloading page');
        // Force page reload for guaranteed UI update
        setTimeout(function() {
          location.reload();
        }, 500);
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { 
        console.log('[ShippingProgress] Error removing automatic gift');
        _giftBusy = false; 
        runPendingCheck(); 
      });
      return;
    }

    if (giftMinReached && !giftItem && nonGiftItemCount > 0) {
      _giftBusy = true;
      getGiftVariantId(getGiftHandle()).then(function(variantId) {
        if (!variantId) { _giftBusy = false; runPendingCheck(); return; }
        return addGiftToCart(variantId).then(function() {
          return reloadCartSections();
        });
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    } else if (giftMinReached && giftItem && !isAutomaticGift(giftItem)) {
      _giftBusy = true;
      convertToAutomaticGift(giftItem.key, 1).then(function() {
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    } else if (giftMinReached && giftItem && giftItem.quantity > 1) {
      _giftBusy = true;
      setGiftQuantityTo1(giftItem.key).then(function() {
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    } else if (!giftMinReached && giftItem && isAutomaticGift(giftItem)) {
      console.log('[ShippingProgress] Removing gift - min value not reached');
      _giftBusy = true;
      removeGiftFromCart(giftItem.key).then(function() {
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    }
  }

  function runPendingSelectorCheck() {
    if (_pendingSelectorCheck) {
      _pendingSelectorCheck = false;
      setTimeout(checkCartAndUpdate, 150);
    }
  }

  // Remove sozinho o brinde escolhido no seletor por foto
  // (snippets/gift-selector.liquid, property "_brinde") assim que o
  // carrinho cair abaixo do valor mínimo configurado em Tema > Carrinho >
  // Seletor de brinde por foto (settings.gift_selector_min_value).
  // Independente do brinde automático acima: não mexe nele, nem é afetado
  // por ele.
  function handleGiftSelectorLogic(cart) {
    var minValue = getGiftSelectorMinValue();
    if (minValue === null) return;

    var selectedGift = findSelectedGiftInCart(cart);
    if (!selectedGift) return;

    // Versão 2 (faixas, snippets/gift-selector-tiers.liquid): cada brinde
    // carrega o valor da sua faixa em _brinde_faixa - quem escolheu um
    // brinde da faixa de R$ 2.000 perde ele ao cair pra R$ 1.800, mesmo
    // com a faixa de R$ 1.500 ainda atingida.
    var threshold = minValue;
    var tierValue = parseFloat(selectedGift.properties._brinde_faixa);
    if (getGiftSelectorLayout() === 'tiers' && !isNaN(tierValue)) {
      threshold = tierValue;
    }

    var totalReaisWithoutGifts = cartTotalWithoutGifts(cart) / 100;
    if (totalReaisWithoutGifts >= threshold) return;

    if (_giftSelectorBusy) {
      _pendingSelectorCheck = true;
      return;
    }

    console.log('[ShippingProgress] Removing selected gift - below gift selector threshold');
    _giftSelectorBusy = true;
    removeSelectedGiftAndPatchDom(selectedGift.key).then(function() {
      _giftSelectorBusy = false;
      runPendingSelectorCheck();
    }).catch(function() {
      _giftSelectorBusy = false;
      runPendingSelectorCheck();
    });
  }

  // Remove a linha do brinde por foto e atualiza o carrinho no lugar (sem
  // location.reload()): pede as sections já na própria chamada de
  // /cart/change.js, aplica .shipping-progress-wrapper e
  // #CartDrawer-GiftSelector com applySectionsUpdate (mesma função usada
  // pelas respostas normais de /cart/add|change|update) e deixa o
  // cart-drawer re-renderizar os itens/rodapé/ícone de verdade via
  // renderContents(), o mecanismo nativo do tema (ver getSectionsToRender
  // em assets/module-add-to-cart.js).
  function removeSelectedGiftAndPatchDom(lineKey) {
    if (!_originalFetch) return Promise.resolve();
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : null;
    var sections = sectionId ? [sectionId, 'cart-icon-bubble'] : [];
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: sections,
        sections_url: window.location.pathname
      })
    }).then(function(r) { return r.json(); })
      .then(function(parsedState) {
        if (parsedState && parsedState.sections) {
          applySectionsUpdate(parsedState.sections);
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState);
          }
        }
        return parsedState;
      });
  }

  function updateIconImage(icon, reached) {
    if (!icon) return;
    var img = icon.querySelector('.shipping-progress__icon-img');
    if (!img) return;
    var defaultSrc = icon.getAttribute('data-icon-default');
    var reachedSrc = icon.getAttribute('data-icon-reached');
    var targetSrc = (reached && reachedSrc) ? reachedSrc : defaultSrc;
    if (targetSrc && img.getAttribute('src') !== targetSrc) {
      img.setAttribute('src', targetSrc);
    }
  }

  function updateProgress(totalCents) {
    var wrappers = document.querySelectorAll('.shipping-progress-wrapper');
    if (wrappers.length === 0) return;

    var total = totalCents / 100;

    wrappers.forEach(function(wrapper) {
      var meta1 = parseFloat(wrapper.getAttribute('data-meta1'));
      var meta2 = parseFloat(wrapper.getAttribute('data-meta2'));
      // Etapa 3 opcional: o Liquid só preenche data-meta3 quando ela está
      // ativada e é maior que a etapa 2.
      var meta3 = parseFloat(wrapper.getAttribute('data-meta3'));
      if (isNaN(meta1)) meta1 = META1_FALLBACK;
      if (isNaN(meta2)) meta2 = META2_FALLBACK;
      var hasStep3 = !isNaN(meta3) && meta3 > meta2;
      var metaFinal = hasStep3 ? meta3 : meta2;

      var step1Label = getStepLabel(1, 'Frete Grátis');
      var step2Label = getStepLabel(2, 'o brinde');
      var step3Label = getStepLabel(3, 'o brinde');

      var percent = Math.min((total / metaFinal) * 100, 100);
      var remaining1 = Math.max(meta1 - total, 0);
      var remaining2 = Math.max(meta2 - total, 0);
      var remaining3 = hasStep3 ? Math.max(meta3 - total, 0) : 0;
      var meta1Reached = total >= meta1;
      var meta2Reached = total >= meta2;
      var meta3Reached = hasStep3 && total >= meta3;

      var fill = wrapper.querySelector('.shipping-progress__fill');
      if (fill) fill.style.width = percent + '%';

      var icons = wrapper.querySelectorAll('.shipping-progress__icon');
      if (icons[0]) {
        icons[0].classList.toggle('is-reached', meta1Reached);
        updateIconImage(icons[0], meta1Reached);
      }
      if (icons[1]) {
        icons[1].classList.toggle('is-reached', meta2Reached);
        updateIconImage(icons[1], meta2Reached);
      }
      if (hasStep3 && icons[2]) {
        icons[2].classList.toggle('is-reached', meta3Reached);
        updateIconImage(icons[2], meta3Reached);
      }

      var msg = wrapper.querySelector('.shipping-progress__message');
      if (msg) {
        if (meta3Reached) {
          msg.innerHTML = '<span>Parabéns! Você ganhou <strong>' + step1Label + '</strong>, <strong>' + step2Label + '</strong> e <strong>' + step3Label + '</strong>!</span>';
        } else if (hasStep3 && meta2Reached) {
          msg.innerHTML = '<span>Adicione mais <strong>R$&nbsp;' + formatBRL(remaining3) + '</strong> e receba <strong>' + step3Label + '</strong>!</span>';
        } else if (meta2Reached) {
          msg.innerHTML = '<span>Parabéns! Você ganhou <strong>' + step1Label + '</strong> e <strong>' + step2Label + '</strong>!</span>';
        } else if (meta1Reached) {
          msg.innerHTML = '<span>Adicione mais <strong>R$&nbsp;' + formatBRL(remaining2) + '</strong> e receba <strong>' + step2Label + '</strong>!</span>';
        } else {
          msg.innerHTML = '<span>Adicione mais <strong>R$&nbsp;' + formatBRL(remaining1) + '</strong> e receba <strong>' + step1Label + '</strong>!</span>';
        }
      }
    });
  }

  // Aplica instantaneamente o HTML já renderizado pelo servidor (vindo da própria
  // resposta de /cart/add.js, /cart/change.js etc quando pedem sections=...), sem
  // esperar o debounce/rate-limit de checkCartAndUpdate. É isso que resolve a troca
  // de ícone (e da barra/mensagem) no exato instante em que o valor é atingido.
  function applySectionsUpdate(sections) {
    if (!sections) return false;
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : null;
    var html = sectionId ? sections[sectionId] : null;
    if (!html) return false;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var handled = false;

    var newWrapper = doc.querySelector('.shipping-progress-wrapper');
    var oldWrapper = document.querySelector('.shipping-progress-wrapper');
    if (newWrapper && oldWrapper) {
      oldWrapper.innerHTML = newWrapper.innerHTML;
      ['data-cart-total', 'data-meta1', 'data-meta2', 'data-meta3'].forEach(function(attr) {
        var value = newWrapper.getAttribute(attr);
        if (value !== null) oldWrapper.setAttribute(attr, value);
      });
      handled = true;
    }

    // O carrossel de escolha de brinde (Tema > Carrinho > Carrossel de
    // escolha de brinde) some/aparece sozinho conforme o total do carrinho
    // cruza o valor mínimo configurado, mas fica fora do fluxo normal de
    // getSectionsToRender() do cart-drawer. Reaplicamos o HTML atualizado
    // vindo do servidor pra ele acompanhar o carrinho em tempo real.
    var newGiftSelector = doc.querySelector('#CartDrawer-GiftSelector');
    var oldGiftSelector = document.querySelector('#CartDrawer-GiftSelector');
    if (newGiftSelector && oldGiftSelector) {
      oldGiftSelector.innerHTML = newGiftSelector.innerHTML;
      handled = true;
    }

    // Mesmo motivo pro bloco de item promocional (snippets/promo-selector.liquid):
    // o resumo "no carrinho" aparece/some conforme o item entra/sai.
    var newPromoSelector = doc.querySelector('#CartDrawer-PromoSelector');
    var oldPromoSelector = document.querySelector('#CartDrawer-PromoSelector');
    if (newPromoSelector && oldPromoSelector) {
      oldPromoSelector.innerHTML = newPromoSelector.innerHTML;
      handled = true;
    }

    return handled;
  }

  function checkCartAndUpdate() {
    if (!_originalFetch) return;

    // Rate limiting to avoid connection verification issues
    var now = Date.now();
    if (now - _lastRequestTime < 2000) { // Minimum 2 seconds between requests
      console.log('[ShippingProgress] Request throttled to prevent rate limiting, retrying shortly');
      clearTimeout(_throttleRetryTimer);
      _throttleRetryTimer = setTimeout(checkCartAndUpdate, 2100 - (now - _lastRequestTime));
      return;
    }

    _lastRequestTime = now;
    _requestCount++;
    
    // Reset counter every minute
    if (_requestCount > _maxRequestsPerMinute) {
      console.log('[ShippingProgress] Rate limit reached, skipping request');
      return;
    }
    
    setTimeout(function() {
      _requestCount = Math.max(0, _requestCount - 1);
    }, 60000);
    
    _originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var totalWithoutGift = cartTotalWithoutGifts(cart);
        updateProgress(totalWithoutGift);
        handleGiftLogic(cart);
        handleGiftSelectorLogic(cart);
      })
      .catch(function() {});
  }

  window.ShippingProgressCheckCart = checkCartAndUpdate;

  function debouncedCheck() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(checkCartAndUpdate, 1000);
  }

  document.addEventListener('cart:updated', debouncedCheck);
  document.addEventListener('cart:refresh', debouncedCheck);
  document.addEventListener('cart:change', debouncedCheck);
  
  // Override cart remove button functionality
  function overrideCartRemoveButtons() {
    var removeButtons = document.querySelectorAll('cart-remove-button, main-cart-remove-button');
    removeButtons.forEach(function(button) {
      if (!button.hasAttribute('data-gift-override')) {
        button.setAttribute('data-gift-override', 'true');
        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          console.log('[ShippingProgress] Cart remove button clicked with override');
          
          // Get the original click handler's data
          var index = this.dataset.index;
          var key = this.dataset.key;
          var embroideryId = this.dataset.embroideryId;
          
          // Call the original removal logic
          if (embroideryId) {
            // Handle embroidery items
            var escapedId = window.CSS && window.CSS.escape ? window.CSS.escape(embroideryId) : embroideryId.replace(/"/g, '\\"');
            var currentIndex = Number(index);
            var currentKey = key;
            var matchingButtons = Array.from(document.querySelectorAll('cart-remove-button[data-embroidery-id="' + escapedId + '"], main-cart-remove-button[data-embroidery-id="' + escapedId + '"]'));
            var items = [{
              key: currentKey,
              line: Number.isFinite(currentIndex) ? currentIndex : null,
            }, ...matchingButtons.map(function(btn) {
              return {
                key: btn.dataset.key,
                line: Number(btn.dataset.index),
              };
            })];
            
            if (items.some(function(item) { return item && item.key; })) {
              // Find the ProductForm instance and call updateQuantitiesByKey
              var productForm = button.closest('product-form') || document.querySelector('product-form');
              if (productForm && typeof productForm.updateQuantitiesByKey === 'function') {
                productForm.updateQuantitiesByKey(items, 0);
              }
            }
          } else {
            // Handle regular items
            var productForm = button.closest('product-form') || document.querySelector('product-form');
            if (productForm && typeof productForm.updateQuantity === 'function') {
              productForm.updateQuantity(index, 0);
            }
          }
          
          // Force gift check after removal with immediate removal logic
          setTimeout(function() {
            console.log('[ShippingProgress] Forcing gift check after removal');
            if (!isAutoAddEnabled()) {
              checkCartAndUpdate();
              return;
            }
            var giftProductId = getGiftProductId();
            if (!giftProductId) {
              checkCartAndUpdate();
              return;
            }
            _originalFetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                console.log('[ShippingProgress] Cart after removal:', cart);
                var giftItem = findGiftInCart(cart, giftProductId);
                var nonGiftItemCount = 0;
                if (cart && cart.items) {
                  for (var i = 0; i < cart.items.length; i++) {
                    if (!isConfiguredGiftItem(cart.items[i], giftProductId)) {
                      nonGiftItemCount++;
                    }
                  }
                }
                
                console.log('[ShippingProgress] Non-gift items count:', nonGiftItemCount);
                console.log('[ShippingProgress] Gift item found:', !!giftItem);
                
                // If no regular products and automatic gift exists, remove it immediately
                if (nonGiftItemCount === 0 && giftItem && giftItem.properties && giftItem.properties._brinde_automatico === 'true') {
                  console.log('[ShippingProgress] IMMEDIATE AUTOMATIC GIFT REMOVAL - No regular products left');
                  _giftBusy = true;
                  _originalFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: giftItem.key, quantity: 0 })
                  }).then(function(r) { return r.json(); })
                    .then(function() {
                      console.log('[ShippingProgress] Automatic gift removed successfully, reloading page');
                      // Direct page reload for guaranteed UI update
                      location.reload();
                    })
                    .catch(function(error) {
                      console.log('[ShippingProgress] Error removing automatic gift:', error);
                      _giftBusy = false;
                    });
                } else {
                  console.log('[ShippingProgress] Keeping gift - either manual gift or regular products exist');
                  checkCartAndUpdate();
                }
              })
              .catch(function(error) {
                console.log('[ShippingProgress] Error checking cart:', error);
              });
          }, 1500);
        });
      }
    });
  }
  
  // Run override immediately only
  overrideCartRemoveButtons();

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      this.addEventListener('load', function() {
        var url = this._url || '';
        if (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1 ||
          url.indexOf('sections=') !== -1 ||
          url.indexOf('section_id=') !== -1
        ) {
          debouncedCheck();
        }
      });
      this._url = arguments[1];
      origOpen.apply(this, arguments);
    };
  }

  function requestSkipsCartSideEffects(init) {
    if (!init || !init.headers) return false;
    var headers = init.headers;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.get('X-Lili-Shipping-Quote') === '1';
    }
    if (typeof headers === 'object') {
      return (
        headers['X-Lili-Shipping-Quote'] === '1' ||
        headers['x-lili-shipping-quote'] === '1'
      );
    }
    return false;
  }

  if (window.fetch) {
    window.fetch = function() {
      var args = arguments;
      var init = args[1] || {};
      var skipSideEffects = requestSkipsCartSideEffects(init);
      return _originalFetch.apply(this, args).then(function(response) {
        if (skipSideEffects) return response;

        var url = '';
        if (typeof args[0] === 'string') {
          url = args[0];
        } else if (args[0] && args[0].url) {
          url = args[0].url;
        }
        if (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1 ||
          url.indexOf('sections=') !== -1 ||
          url.indexOf('section_id=') !== -1
        ) {
          try {
            var clone = response.clone();
            clone.json().then(function(data) {
              if (data && data.sections) {
                applySectionsUpdate(data.sections);
              }
              debouncedCheck();
            }).catch(function() {
              debouncedCheck();
            });
          } catch(e) {
            debouncedCheck();
          }
        }
        return response;
      });
    };
  }

  checkCartAndUpdate();

  // Manual trigger for debugging
  window.forceRemoveGift = function() {
    console.log('[ShippingProgress] Manual gift removal triggered');
    var giftProductId = getGiftProductId();
    if (!giftProductId) {
      console.log('[ShippingProgress] No gift product configured');
      return;
    }
    _originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        console.log('[ShippingProgress] Current cart:', cart);
        var giftItem = findGiftInCart(cart, giftProductId);
        if (giftItem) {
          console.log('[ShippingProgress] Found gift item:', giftItem);
          _giftBusy = true;
          removeGiftFromCart(giftItem.key).then(function() {
            console.log('[ShippingProgress] Gift removed manually');
            return reloadCartSections();
          }).then(function() {
            _giftBusy = false;
          }).catch(function(error) {
            console.log('[ShippingProgress] Error removing gift manually:', error);
            _giftBusy = false;
          });
        } else {
          console.log('[ShippingProgress] No gift found in cart');
        }
      })
      .catch(function(error) {
        console.log('[ShippingProgress] Error getting cart:', error);
      });
  };

  // Removed MutationObserver to prevent excessive requests

  console.log('[ShippingProgress] Script loaded globally from theme.liquid');
  console.log('[ShippingProgress] Manual trigger available: window.forceRemoveGift()');
})();
